import { render, staticRenderFns } from "./TagLabel.vue?vue&type=template&id=0639f7c0&scoped=true&"
import script from "./TagLabel.vue?vue&type=script&lang=js&"
export * from "./TagLabel.vue?vue&type=script&lang=js&"
import style0 from "./TagLabel.vue?vue&type=style&index=0&id=0639f7c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0639f7c0",
  null
  
)

export default component.exports